angular.module('app').factory('customCSSService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer) {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var pages = restAngular.all("/customCss/");

        return {
            loadCSS: function () {
                return pages.
                one("get").
                get()
            },
            loadCSSMobile: function () {
                return pages.
                one("getMobile").
                get()
            },
            save: function (requestData) {
                return pages.
                one("apply").
                post("", requestData)
            },
            saveMobile: function (requestData) {
                return pages.
                one("applyMobile").
                post("", requestData)
            },
            preview: function (requestData) {
                return pages.
                one("preview").
                post("", requestData)
            },
            previewMobile: function (requestData) {
                return pages.
                one("previewMobile").
                post("", requestData)
            },
            getURL: function () {
                return pages.
                one("getCustomCssUrl").
                get()
            },
            getMobileURL: function () {
                return pages.
                one("getMobileCustomCssUrl").
                get()
            }
        }
    }
]);
